import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, computed, effect, ElementRef, input, signal, viewChild, ViewEncapsulation } from '@angular/core';
import { EnpsControlComponent } from '@common/controls/enps-control/enps-control';

@Component({
    selector: 'st-text-area',
    templateUrl: './st-text-area.html',
    styleUrls: ['./st-text-area.scss'],
    host: {
        class: 'st-text-area',
    },
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StTextAreaComponent extends EnpsControlComponent<string> {
    textToHighlight = input<string>('');
    showLinks = input(false, {
        transform: coerceBooleanProperty,
    });

    display = viewChild<ElementRef<HTMLDivElement>>('display');
    inEditMode = signal(true);
    internalValue = signal<string>('');

    displayValue = computed(() => {
        return this.internalValue() || this.placeholder();
    });

    constructor() {
        super();
        effect(
            () => {
                this.inEditMode.set(!this.showLinks());
                this.internalValue.set(this.value());
            },
            { allowSignalWrites: true }
        );
    }

    onNgModelChanged(value: string) {
        this.internalValue.set(value);
    }

    onValueChanged() {
        this.changed.emit(this.internalValue());
        if (this.showLinks() && !this.disabled()) {
            this.inEditMode.set(false);
        }
    }

    onBlur() {
        if (this.showLinks() && !this.disabled()) {
            this.inEditMode.set(false);
        }
    }

    onFocus() {
        if (this.showLinks() && !this.disabled()) {
            this.inEditMode.set(true);
        }
    }

    onScroll(event) {
        this.display().nativeElement.scrollTop = event.target.scrollTop;
    }
}
